<template>
  <div>
    <success-fade-alert ref="alertSuccess" :msg="alert.success" />
    <fade-alert-danger ref="alertDanger" :msg="alert.error" />

    <b-row>
      <h2>
        {{ $t("checklist.form.edit") + " " + $t("geral.vehicleModel") }}
      </h2>
    </b-row>

    <b-row>
      <b-button @click="voltar()" size="sm">
        {{ $t("geral.back") }}
      </b-button>
    </b-row>

    <b-row class="mt-4">
      <b-col lg="6" md="6" sm="6">
        <VehicleModel :model="model" :modelstate="modelstate" />
      </b-col>
    </b-row>

    <b-row v-if="$store.getters.accessRevisionModelCrud">
      <b-col lg="6" md="6" sm="6">
        <revision-modal :model.sync="model" />
      </b-col>
    </b-row>

    <b-row style="margin-top: 40px">
      <b-button @click="edit" size="sm">
        {{ $t("geral.save") }}
      </b-button>
    </b-row>
  </div>
</template>

<script>
export default {
  components: {
    VehicleModel: () =>
      import("@/components_rms/System/VehicleModel/VehicleModel.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    RevisionModal: () =>
      import("@/components_rms/vehicle/Revision/RevisionModal.vue")
  },
  data() {
    return {
      modelstate: {},
      alert: {
        error: "",
        success: "Registro Editado com sucesso"
      },
      idModelVehicle: this.$route.params.id,
      model: {
        name: null,
        size: null,
        brandId: null,
        revisions: []
      }
    };
  },
  mounted() {
    this.getBrandVehicle();
  },
  methods: {
    edit() {
      this.modelstate = {};
      let obj = {
        name: this.model.name,
        size: this.model.size,
        brandId: this.model.brandId,
        revisions: this.model.revisions
      };
      this.$apiVehicle
        .put(`/vehicleModel/edit/${this.idModelVehicle}`, obj)
        .then(response => {
          if (response.data.status == 500) {
            this.alert.error = response.data.title;
            this.$refs.alertDanger.show();
          } else {
            this.$refs.alertSuccess.show();
          }
        })
        .catch(error => {
          if (error.response.status == 400) {
            this.modelstate = error.response.data.errors;
          }
        });
    },
    getBrandVehicle() {
      this.$apiVehicle
        .get(`/vehicleModel/get/${this.idModelVehicle}`)
        .then(response => {
          this.model.name = response.data.name;
          this.model.size = response.data.size;
          this.model.brandId = response.data.brandId;
          this.model.revisions = response.data.revisions;
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    voltar() {
      this.$router.go(-1);
    }
  }
};
</script>
